// Must match CLIENT_FACING_ERROR_CODE in the GraphQL server's lib/errors.ts.
export const CLIENT_FACING_ERROR_CODE = "CLIENT_FACING"

type GraphQLErrorLike = {
  extensions?: { code?: unknown } | null
}

type ApolloErrorLike = {
  graphQLErrors?: GraphQLErrorLike[]
  clientErrors?: unknown[]
  protocolErrors?: unknown[]
  networkError?: unknown
}

// True when every error in an ApolloError is an expected, user-facing failure
// (e.g. "Invalid password") that the UI already shows.
export const isClientFacingApolloError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false

  const { graphQLErrors, clientErrors, protocolErrors, networkError } =
    error as ApolloErrorLike

  if (!Array.isArray(graphQLErrors) || !graphQLErrors.length) return false
  if (networkError || clientErrors?.length || protocolErrors?.length)
    return false

  return graphQLErrors.every(
    (graphQLError) =>
      graphQLError?.extensions?.code === CLIENT_FACING_ERROR_CODE
  )
}
